import { HttpClient } from '@angular/common/http';
import { Component, inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbDate, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { ModalStockItemComponent } from 'src/app/components/inventory-modals/modal-stock-item.component';
import { Stock } from 'src/app/models/stock';
import { InventoryService } from 'src/app/services/inventory.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-index-inventory',
  template: `
  <div class="d-flex mb-4 mt-4">
    <h1>Inventario</h1>
  </div>
  <div class="d-flex">
    <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
      <ul #sidebar app-nav-inventory [currentView]="currentView" class="list-unstyled"></ul>
    </div>
    <div #pages class="flex-fill">
      <div class="d-flex">
        <div>
          <div ngbDropdown class="d-inline-block" (click)="datepicker.toggle()">
            <button type="button" class="btn btn-zazz-default rounded-4 px-4 shadow-sm" id="dropdownForm1" ngbDropdownToggle>
              <fa-icon [icon]="icons.faCalendarAlt" class="me-2"></fa-icon>
              Este mes
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownForm1" class="shadow" style="width: 650px;">
              <div class="row">
                <div class="col-3">
                  <ul class="list-group calendar-list-group ps-2 mt-2">
                    <li class="list-group-item list-group-item-action active">Hoy</li>
                    <li class="list-group-item list-group-item-action">Ayer</li>
                    <li class="list-group-item list-group-item-action">Este mes</li>
                    <li class="list-group-item list-group-item-action">Últimos 7 días</li>
                    <li class="list-group-item list-group-item-action">Últimos 30 días</li>
                    <li class="list-group-item list-group-item-action">Personalizado</li>
                  </ul>
                </div>
                <div class="col-9" style="height: 320px;">
                  <div class="input-group">
                    <input
                      #dpFromDate
                      class="form-control"
                      style="width: 0px !important; height: 0px !important; opacity: 0;"
                      ngbDatepicker
                      #datepicker="ngbDatepicker"
                      [autoClose]="'outside'"
                      (dateSelect)="onDateSelection($event)"
                      [displayMonths]="2"
                      [dayTemplate]="t"
                      outsideDays="hidden"
                      [startDate]="fromDate!"
                      tabindex="-1" 
                    />
                    <ng-template #t let-date let-focused="focused">
                      <span
                        class="custom-day"
                        [class.focused]="focused"
                        [class.range]="isRange(date)"
                        [class.faded]="isHovered(date) || isInside(date)"
                        (mouseenter)="hoveredDate = date"
                        (mouseleave)="hoveredDate = null"
                      >
                        {{ date.day }}
                      </span>
                    </ng-template>
                  </div>
                </div>
                <div class="col-12">
                  <div class="dropdown-divider"></div>
                  <div class="d-flex text-end flex-fill flex-row-reverse me-2">
                    <button type="button" class="btn btn-zazz-dark ms-2 rounded-4 shadow-sm btn-sm px-4">Aplicar</button>     
                    <button type="button" class="btn btn-zazz-default rounded-4 shadow-sm btn-sm px-4">Cancelar</button>                      
                  </div>                           
                </div>
              </div>                  
            </div>
          </div>
        </div>
        <div class="flex-fill">
          <button class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm">
            <fa-icon [icon]="icons.faSliders" class="me-2"></fa-icon>
            Filtrar búsqueda
          </button>
        </div>
        <div class="flex-fill">
          <button class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm" 
            *ngIf="authService.hasPermission('can_create_stock')"
            (click)="openModalStockItem()">
            <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
            Agregar
          </button>
        </div>
        <div class="flex-fill ms-2" [formGroup]="searchForm">
          <input type="text" 
            class="form-control rounded-4 border border-1 border-secondary" 
            placeholder="Buscar inventario" 
            formControlName="search">
        </div>
      </div>
      <div class="d-flex mt-2">
        <div class="flex-fill">
          <div class="list-group rounded-5 shadow mt-4" >
            <div class="list-group-item w-100" >
              <table class="table table-sm mt-3" style="overflow-x: scroll;">
                <thead class="thead-dark">
                  <tr class="">
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3"># Nombre <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">SKU</th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Descripción</th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Cantidad</th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Ctd. Mínima</th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Empresa</th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Unidad medida</th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Última actualización</th>
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2">Valor unidad</th>
                  </tr>
                </thead>
                <tbody>
                  <tr app-tr-inventory
                    [stock]="stk"
                    [profile]="profile" 
                    [permissions]="permissions"
                    *ngFor="let stk of stock | paginate: { 
                      itemsPerPage: payload.per_page, 
                      currentPage: p, 
                      totalItems: meta.total_entries 
                    }"
                  ></tr>
                </tbody>
              </table>
            </div>
            <div class="list-group-item text-center pt-3">
              <pagination-controls
                (pageChange)="p = $event"
                (pageChange)="pageChanged($event)"
                previousLabel="Prev."
                nextLabel="Sig."
                screenReaderPaginationLabel="Pagination"
                screenReaderPageLabel="page"                  
              ></pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-modal-stock-item
    (stockCreated)="loadStock(payload)"
  ></app-modal-stock-item>
  `,
  styleUrls: []
})
export class IndexInventoryComponent {

  @ViewChild(ModalStockItemComponent, { static: true }) modalStockItemComponent !: ModalStockItemComponent;
  apiUrl: string = environment.AWS_REST_WSPREFIX;

  stock: Stock[] = [];
  meta: any = {};
  profile: any;
  permissions: any;

  currentView = 'stock';

  payload: any = {
    page: 1,
    per_page: 100,
    order: 'DESC'
  }
  p: number = 1;

  payFilterPrefs: any = {};
  searchForm: FormGroup = new FormGroup({});
  filteredStock: any[] = [];
  a = new Date();
  fromDate;
  toDate;
  
  hoveredDate: NgbDate | null = null;
  storageService = inject(StorageService);
  constructor(
    public icons: IconsService,
    public images: ImageService,
    private offcanvasService: NgbOffcanvas,
    private invStore: InventoryService,
    private http: HttpClient,
    private toastr: ToastrService,
    public authService: AuthService,
    private fb: FormBuilder
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS);
    // this.payload.profile_id = this.profile.id;
    this.searchForm = this.fb.group({
      search: ['']
    });

    this.searchForm.get('search')?.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe(searchTerm => {
        this.filterStock(searchTerm);
      });

    if (this.a.getMonth() == 0) {
      console.log('IS JANUARY');
      this.fromDate = new NgbDate(this.a.getFullYear() - 1, 12, 1);
    } else {
      this.fromDate = new NgbDate(this.a.getFullYear(), this.a.getMonth(), 1);
    }

    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, 29);
    this.payload.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.payload.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
    this.payFilterPrefs = this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) ? this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) : this.payload;
    // this.payFilterPrefs.state = [1,2];
    // this.payFilterPrefs.status = true;
    // this.payFilterPrefs.profile_id = this.profile.id;

    console.log('prefs ==> ', this.payFilterPrefs);
    this.p = this.payFilterPrefs.page;
  }

  ngOnInit(): void {
    this.loadStock(this.payload);
  }

  loadStock(payload: any) {
    this.invStore.getStock(payload).subscribe({
      next: (response: any) => {
        console.log('STOCK RESPONSE => ', response);
        this.stock = response.data;
        this.meta = response.meta;
        this.filteredStock = this.stock; // Initialize filtered stock with all stock items
      },
      error: (error) => {
        console.error('Error loading stock:', error);
        this.toastr.error('No se pudo cargar el inventario', 'Error');
      }
    });
  }

  filterStock(searchTerm: string) {
    if (!searchTerm) {
      this.filteredStock = this.stock;
      return;
    }

    searchTerm = searchTerm.toLowerCase();
    this.filteredStock = this.stock.filter((item: any) => 
      item.name?.toLowerCase().includes(searchTerm) ||
      item.sku?.toLowerCase().includes(searchTerm) ||
      item.description?.toLowerCase().includes(searchTerm)
    );
  }

  openModalStockItem() {
    const modalTemplate: any | undefined = this.modalStockItemComponent;
    if (modalTemplate) {
      modalTemplate.openModal(modalTemplate['modalStockItem']);
    }
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.fromDate = date;
    }
  }
  
  isHovered(date: NgbDate) {
    return this.fromDate;
    // return (
      // this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    // );
  }
  
  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }
  
  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  downloadReport() {
    const apiUrl = `https://receipt-test.zazz.mx/public/proforma_autogenerado.xlsx`;
    
    // Show loading message
    this.toastr.info('Generando reporte...', 'Por favor espere');
    
    // Make HTTP request to get the file
    this.http.get(apiUrl, {
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    }).subscribe({
      next: (blob: Blob) => {
        // Create a URL for the blob
        const url = window.URL.createObjectURL(blob);
        
        // Create a temporary anchor element
        const a = document.createElement('a');
        a.href = url;
        
        // Set filename with current date
        const currentDate = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD
        a.download = `reporte_proforma_inventario_${currentDate}.xlsx`;
        
        // Append to body, click and remove
        document.body.appendChild(a);
        a.click();
        
        // Clean up
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        
        this.toastr.success('Reporte descargado correctamente', 'Éxito');
      },
      error: (error) => {
        console.error('Error downloading report:', error);
        this.toastr.error('No se pudo descargar el reporte', 'Error');
      }
    });
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadStock(this.payload);
  }

}
